module.exports = __webpack_public_path__ + "static/media/iRetailARHero.56570356.jpg";